import Divider from './Divider.vue'

export default Divider
